<template>
  <div class="container-fluid">
    <b-row>
      <b-col class="col">

      </b-col>
    </b-row>

    <b-row style="margin-top: 15px">
      <b-col cols="12" class="tabla-problemas">
        <!--<b-card header="Banco de Problemas"
                border-variant="light">-->
        <b-row>
          <b-col md="6" style="padding-top: 3%">
            <h3 class="text-uppercase font-weight-bold" style="padding-top: 5%">Proyectos</h3>
          </b-col>
          <b-col md="6" style="padding-top: 4%">
            <b-form-group style="background-color: rgb(228, 231, 234); border-radius: 23px">
              <b-input-group>
                <b-form-input id="elementsPrependAppend" type="text" v-model="filter" placeholder="" class="buscar"
                              style="background-color: rgb(241, 242, 243);border-color: transparent"></b-form-input>
                <b-input-group-append>
                  <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" class="buscar"><i
                    class="fa fa-search"
                    style="font-size: 24px;color: #1E3375"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <!--<p class="font-weight-bold">Puede filtrar por:</p>-->
            <!--<b-row class="container container-fluid">
              <b-col cols="2">
                <label class="font-weight-bold">Año:</label>
                <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.anos">
                  <template slot="first">
                    <option :value="null">Año</option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="4">
                <label class="font-weight-bold">Áreas de Conocimiento:</label>
                <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.area">
                  <template slot="first">
                    <option :value="null">Áreas de Conocimiento</option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="2">
                <label class="font-weight-bold">Alcance:</label>
                <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.alcance">
                  <template slot="first">
                    <option :value="null">Alcance</option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="2">
                <label class="font-weight-bold">Estado:</label>
                <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.estado">
                  <template slot="first">
                    <option :value="null">Estado</option>
                  </template>
                </b-form-select>
              </b-col>
            </b-row>-->
            <!--<b-form-group horizontal label="" class="mb-0" style="padding-top: 3%">
              <b-input-group>
                <b-form-input v-model="filter" placeholder=""/>
                <b-input-group-append>
                  <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" ><i class="fa fa-search"
                                                                                                   style="font-size: 24px;color: #D5D9DE"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>-->
          </b-col>
        </b-row>

        <b-row class="container container-fluid">
          <p class="font-weight-bold">Puede filtrar por:</p>
          <b-col cols="2">
            <label class="font-weight-bold">Año</label>
            <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.anos">
              <template slot="first">
                <option :value="null">Año</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="4">
            <label class="font-weight-bold">Áreas de Conocimiento</label>
            <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.area">
              <template slot="first">
                <option :value="null">Áreas de Conocimiento</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <label class="font-weight-bold">Alcance</label>
            <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.alcance">
              <template slot="first">
                <option :value="null">Alcance</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <label class="font-weight-bold">Estado</label>
            <b-form-select class="mb-3 form-filters" v-model="filter" :options="this.estado">
              <template slot="first">
                <option :value="null">Estado</option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>

        <!--TABLA-->
        <b-row style="max-width: 98%; margin-left: 10px;">
          <b-table responsive
                   striped
                   :items="proyectos"
                   :fields="fields"
                   :current-page="currentPage"
                   :per-page="perPage"
                   :filter="filter"
                   @filtered="onFiltered" style="color:#1E3375">
            <template slot="titulo" slot-scope="data">
              <p class="text-justify">{{data.item.titulo}}</p>
            </template>
            <template slot="area_conocimiento" slot-scope="data">
              <ul style="list-style-type:none">
                <li v-for="item in data.item.area_conocimiento">
                  {{ item }}
                </li>
              </ul>
            </template>

            <template slot="show_details" slot-scope="row">
              <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
              <b-button size="sm" @click.stop="row.toggleDetails" variant="light" class="btn btn-pill mr-2">
                {{ row.detailsShowing ? 'Ocultar' : 'Mostrar'}} Proyecto
              </b-button>
              <!-- In some circumstances you may need to use @click.native.stop instead -->
              <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col cols md="auto" class="text-sm-left"><span class="font-weight-bold">Investigadores: </span>
                  </b-col>
                  <b-col cols md="auto">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item investigador" v-for="item in row.item.investigadores">
                        {{ item }}
                      </li>
                    </ul>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col class="text-sm-left"><span class="font-weight-bold">Objetivo: </span>{{row.item.objetivo }}
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col class="text-sm-left"><span class="font-weight-bold">Año: </span>{{row.item.ano }}
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col class="text-sm-left"><span class="font-weight-bold">Alcance: </span>{{row.item.alcance }}
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col class="text-sm-left"><span class="font-weight-bold">Estado: </span>{{row.item.estado }}</b-col>
                </b-row>
                <b-row class="mb-2" v-show="row.item.financiamiento">
                  <b-col cols md="auto" class="text-sm-left"><span
                    class="font-weight-bold">Entidades financiadoras: </span></b-col>
                  <b-col cols md="auto">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item investigador" v-for="item in row.item.financiadoras">
                        {{ item }}
                      </li>
                    </ul>
                  </b-col>
                </b-row>
                <!--<b-row class="mb-2" v-show="row.item.financiamiento">
                  <b-col class="text-sm-left"><span class="font-weight-bold">Financiamiento:
                                              </span>{{row.item.financiado | currency('$','.',2,',','front',true) }}
                  </b-col>
                </b-row>-->
                <b-row class="mb-2" v-show="!row.item.financiamiento">
                  <b-col class="text-sm-left"><span class="font-weight-bold">Proyecto sin financiamiento</span></b-col>
                </b-row>
                <!--<b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Is Active:</b></b-col>
                  <b-col>{{ row.item.isActive }}</b-col>
                </b-row>-->
                <!--<b-button size="sm" @click="row.toggleDetails" class="btn btn-pill btn-block btn-warning">Ocultar Problema</b-button>-->
              </b-card>
            </template>
          </b-table>
        </b-row>
        <b-row>
          <b-col class="my-1">
            <b-pagination align="center" :total-rows="totalRows" :per-page="perPage"
                          :hide-goto-end-buttons="true"
                          prev-text='<i class="fa fa-caret-left" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                          next-text='<i class="fa fa-caret-right" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                          v-model="currentPage" class="pagination"/>
          </b-col>
        </b-row>
        <!--   </b-card>-->
      </b-col>


      <!--<b-col cols="4" offset-md="1" style="background-color: #F7F7F9" class="selector-problemas">
        <div role="tablist">
          <b-card no-body class="mb-1" style="background-color: #F7F7F9">
            <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9" class="selector-header">
              <b-btn block href="#" v-b-toggle.dimension variant="light"
                     class="text-left text-uppercase font-weight-bold selector-dimensiones"
                     style="color: #1E3375;background-color: #F7F7F9">Dimensiones
              </b-btn>
            </b-card-header>
            <b-collapse id="dimension" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-list-group>
                  <b-list-group-item button v-for="value in this.dimensionesVista" :key="value.id"
                                     class="d-flex justify-content-between align-items-center btn-pill listado"
                                     @click="filter = value.titulo" id="listado">
                    {{value. titulo}}
                    <b-badge variant="light" pill class="lista-badge" id="badge">{{value.count}}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <div role="tablist" style="background-color: #F7F7F9">
          <b-card no-body class="mb-1" style="background-color: #F7F7F9">
            <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9">
              <b-btn block href="#" v-b-toggle.linea variant="light" class="text-left text-uppercase font-weight-bold"
                     style="color: #1E3375;background-color: #F7F7F9">Línea de investigación
              </b-btn>
            </b-card-header>
            <b-collapse id="linea" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-list-group>
                  <b-list-group-item button v-for="value in this.lineasVista" :key="value.id"
                                     class="d-flex justify-content-between align-items-center btn-pill listado"
                                     @click="filter = value.titulo" id="listado">
                    {{value. titulo}}
                    <b-badge variant="light" pill class="lista-badge" id="badge">{{value.count}}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

      </b-col>-->
    </b-row>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import VueCurrencyFilter from 'vue-currency-filter'

  export default {
    name: "proyectos",
    components: {
      //VueCurrencyFilter,
    },
    data() {
      return {
        slide: 0,
        sliding: null,
        problemasData: [],
        fields: {
          titulo: {sortable: true},
          investigador_principal: {label: 'Investigador principal', sortable: true, 'class': 'text-center'},
          area_conocimiento: {label: 'Áreas de Conocimiento', sortable: true},
          show_details: {label: 'Detalles'},
        },
        items: [],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        filter: null,
        ceroBadge: false,
        selected: null,
      }
    },
    methods: {
      ...mapActions(['getProyectos', 'getAreas']),
    },
    computed: {
      ...mapGetters(['proyectos', 'areas']),
      anos() {
        return [...new Set(this.proyectos.map(proyecto => proyecto.ano))]
      },
      area() {
        return this.areas.map(area => area.nombre)
      },
      alcance() {
        return [...new Set(this.proyectos.map(proyecto => proyecto.alcance))]
      },
      estado() {
        return [...new Set(this.proyectos.map(proyecto => proyecto.estado))]
      },
      totalRows() {
        return this.proyectos.length
      },
    },
    /*beforeUpdate() {
      this.getProyectos()
      this.items = this.$store.state.proyectos.proyectos
      this.getAreas()
      this.totalRows = this.$store.state.proyectos.proyectos.length
      console.log(this.proyectos.length)
    },*/
    created() {
      this.getProyectos()
      this.items = this.$store.state.proyectos.proyectos
      this.getAreas()
      this.totalRows = this.$store.state.proyectos.proyectos.length
      console.log(this.proyectos.length)
    }
  }
</script>

<style scoped>
  .form-filters {
    background: rgb(228, 231, 234);
    border-radius: 23px;
  }

</style>



// WEBPACK FOOTER //
// src/views/frontend/proyectos.vue